
/* eslint-disable @typescript-eslint/no-explicit-any */
import { defineComponent, onBeforeMount, ref } from "vue";
import { useState } from "../../composables/useState";
import { BillingAPI } from "../../services/billing/index";
import Button from "../button/index.vue";
import { createToastAxelerate } from "../../utils/toast";
import Skeleton from "../skeleton/index.vue";
import useClickOutside from "../../composables/useClickOutside";

const PaymentMethods = defineComponent({
  name: "PaymentMethods",
  components: {
    Button,
    Skeleton,
  },
  setup() {
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [loading, setLoading] = useState(false);
    const showModal = ref(false);
    const [defaultPaymentMethod, setDefaultPaymentMethod] = useState(null);
    const { onClickOutside } = useClickOutside();
    const modal = ref(null);
    const cardDefault = ref(false);

    const sortCards = (cards: any) => {
      const fingerprints = [] as Array<string>;
      for (let i = 0; i < cards.length; i++) {
        if (!fingerprints.includes(cards[i].card?.fingerprint)) {
          fingerprints.push(cards[i].card?.fingerprint);
          setPaymentMethods([...paymentMethods.value, cards[i]]);
        }
      }
    };

    const addCard = async () => {
      BillingAPI.stripeAddCard().then((res: any) => {
        window.location.href = res.data.url;
      });
    };

    const getDefaultPaymentMethod = async () => {
      BillingAPI.getStripeCustomer().then((res: any) => {
        setDefaultPaymentMethod(
          res.data.customer.invoice_settings?.default_payment_method
        );
      });
    };

    const removeCard = async (card: any) => {
      showModal.value = false;
      setLoading(true);
      BillingAPI.stripeRemoveCard(card.id).then(async () => {
        await setPaymentMethods(
          paymentMethods.value.filter((payment: any) => payment.id !== card.id)
        );
        await getDefaultPaymentMethod();
        await createToastAxelerate(
          "Payment Methods",
          "The card has been removed",
          "success"
        );
        if (paymentMethods.value.length) {
          setDefaultCard(paymentMethods.value[0]);
        }
        setLoading(false);
      });
    };

    const setDefaultCard = async (card: any) => {
      showModal.value = false;
      setLoading(true);
      BillingAPI.stripeUpdateDefaultCard(card.id).then(async (res: any) => {
        await setDefaultPaymentMethod(res.data.default_payment_method);
        setLoading(true);
        await setPaymentMethods([]);
        await BillingAPI.getPaymentMethods().then(async (res: any) => {
          setLoading(false);
          sortCards(res.data.data);
        });
        await createToastAxelerate(
          "Payment Methods",
          "The default payment method has been changed",
          "success"
        );
      });
      setLoading(false);
    };

    onBeforeMount(async () => {
      setLoading(true);
      await BillingAPI.getPaymentMethods().then(async (res: any) => {
        setLoading(false);
        sortCards(res.data.data);
      });
    });

    const buildLogo = (option: string) => {
      switch (option) {
        case "amex":
          return require("../../assets/svgs/amex.svg");
        case "visa":
          return require("../../assets/svgs/visa.svg");
        case "mastercard":
          return require("../../assets/svgs/mastercard.svg");
        case "us_bank_account":
          return require("../../assets/svgs/ach.svg");
        default:
          return require("../../assets/svgs/generic.svg");
      }
    };

    const removeDefaultCard = (cards: any) => {
      return cards.filter((card: any) => !card.default);
    };

    return {
      sortCards,
      paymentMethods,
      setPaymentMethods,
      addCard,
      getDefaultPaymentMethod,
      defaultPaymentMethod,
      removeCard,
      buildLogo,
      setDefaultCard,
      loading,
      setLoading,
      showModal,
      modal,
      removeDefaultCard,
    };
  },
});

export default PaymentMethods;
